import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface ItemDetailSearchParams {
  keyword?: string;
  itemId?: string;
  itemDetailName?: string;
  supplierVendor?: string;
  materialGrade?: string;
  unitMeasurement?: string;
  inputAreaOfBuy?: string;
  initialDataProcess?: string;
  complianceStandard?: string;
  remarks?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: "asc" | "desc";
}

export const getItemDetails = async (params: ItemDetailSearchParams = {}) => {
  const parsedParams = params.limit? params : {limit: 1000000};
  const response = await axiosInstance.get("/itemDetails/search_item_details", {
    params : parsedParams,
  });

  // Ambil array dari response.data.data
  const parsedData = response.data.data.map((item) => {
    let unitMeasurement = item.unitMeasurement || [];
    if (typeof item.unitMeasurement === "string" && item.unitMeasurement) {
      try {
        unitMeasurement = JSON.parse(item.unitMeasurement);
      } catch (error) {
        console.warn("Failed to parse unitMeasurement:", item.unitMeasurement);
        unitMeasurement = [];
      }
    }
    
    return {
      ...item,
      unitMeasurement,
    };
  });

  return {
    data: parsedData,
    pagination: response.data.pagination,
    total: response.data.total,
  };
};


export const getItems = async () => {
  const response = await axiosInstance.get("/items/view_items");
  return response.data;
};


export const fetchItemPhotoBlob = async (filename: string): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/itemDetails/photo/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};



// Step 1: Create Item
export const createItemDetail = async (data) => {
  data.unitMeasurement = await JSON.stringify(data.unitMeasurement);
  const response = await axiosInstance.post(`/itemDetails/create_item_detail`, data);
  return response.data; // contains the item `id` or `code`
};

// Step 2: Upload Photo by Item ID
export const uploadItemDetailPhoto = async (itemId, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/itemDetails/upload_photo/${itemId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const editItemDetail = async (data) => {
  data.unitMeasurement = await JSON.stringify(data.unitMeasurement);
  const response = await axiosInstance.put(`/itemDetails/update_item_detail/${data.id}`, data);
  return response.data;
};


// Edit Item
export const editItemCategory = async (data) => {
  const formData = {
    name: data.itemGroupName,
    description: data.itemDescription,
    category: data.selectedItem,
  };

  const response = await axiosInstance.put(`/items/update_item/${data.id}`, formData);
  return response.data; // contains the item `id` or `code`
};

export const deleteItemDetail = async (id: string) => {
  const response = await axiosInstance.delete(`/itemDetails/delete_item_detail/${id}`);
  return response.data;
};